<template lang="pug">
  section(id="sud")
     .goscontainer
        v-row(no-gutters)
          v-col(cols=12 md=6)
              div.head Следите за трансляциями судебных заседаний, проводимыми с помощью модуля "Удаленные судебные заседания".
              //div.body Следующий прямой эфир:<br/> понедельник, 12 октября 2020 года, начало в 12:00
          v-col(cols=12 md=6)
              //a(href="/leningrad")
              a(href="/spsudtv")
                v-img.mx-auto(:src="require('@/assets/img/home/sud.png')" max-width="695")
            
</template>

<script>
  export default {
    name: 'SectionSud',
  }
</script>

<style lang="sass" scoped>
  #sud
    padding: 48px 16px 
    background-color: #F3F3F3
    color: #000000
    font-weight: 300
    line-height: 32px
    .head
        font-size: 24px
        margin:60px 100px 40px 100px
    .body
        font-size: 18px
        margin:40px 100px
  @media (max-width: 1180px) 
    #sud
      .head
          margin:0 100px 40px 100px
  @media (max-width: 960px) 
    #sud
      .head
          margin:0 40px 40px 40px
      .body
          margin:40px
</style>
